import * as React from 'react';
import injectStyles from '../jss';
import RPT from 'prop-types';
import styles from './MobileLoginButton.jss';
import { Link } from 'react-router';
var MobileLoginButton = function MobileLoginButton(_ref, _ref2) {
  var classes = _ref.classes,
    hideMenu = _ref.hideMenu,
    isHidden = _ref.isHidden,
    mobileLoginButton = _ref.mobileLoginButton;
  var router = _ref2.router;
  if (isHidden || !mobileLoginButton || mobileLoginButton && router && router.isActive(mobileLoginButton.url, true)) {
    return null;
  }
  return React.createElement(Link, {
    onClick: hideMenu,
    to: mobileLoginButton.url,
    className: classes.base
  }, mobileLoginButton.text);
};
MobileLoginButton.styleRoot = 'MobileLoginButton';
export default injectStyles(styles)(MobileLoginButton);